import { useSuspenseQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@workspace/web-ui/components/card";
import { Label } from "@workspace/web-ui/components/label";
import { Separator } from "@workspace/web-ui/components/separator";
import { Switch } from "@workspace/web-ui/components/switch";
import { useState } from "react";
import { useUpdateNotificationReminders } from "../api/mutations/medications";
import { notificationReminderValues } from "../api/queries";



type ReminderCardProps = {
  refill_reminder?: boolean;
  daily_reminder?: boolean;
};

const ReminderCard: React.FC = () => {

  const reminderValues = useSuspenseQuery(notificationReminderValues())

  console.log("reminder values daily refill",reminderValues.data?.settings?.reminders.daily_reminder);

  const [reminder, setReminder] = useState<ReminderCardProps>({
    refill_reminder: reminderValues.data?.settings?.reminders?.daily_reminder,
    daily_reminder: reminderValues.data?.settings?.reminders?.daily_reminder
  });

 const {mutate: sendReminders} = useUpdateNotificationReminders()

 
 

  const toggleNotificationReminder = (
    field: keyof ReminderCardProps
  ) => {
    const newValue = !reminder[field];

    // Update the local state
    setReminder((prev) => ({
      ...prev, [field]: newValue,
     
    }));

    // Send the updated value to the endpoint
    sendReminders({
      field,
      value: newValue,
    });
  };

  console.log("Reminders:",{...reminder});
  

  return (
    <Card className="md:w-[30%] sm:w-2/5 w-full mt-5 sm:mt-0 max-w-md shadow-md h-1/5">
      <CardHeader className="text-lg font-medium text-left p-5">
        <CardTitle className="text-lg font-medium text-left ">Reminders</CardTitle>
      </CardHeader>
      <Separator />

      <CardContent className="space-y-4 p-0 ">
       
          <div className="flex items-center justify-between p-4 m-0">
            <Label htmlFor="refill" className="text-sm font-medium">Receive notifications when it&apos;s time to refill</Label>
            <Switch
              id="refill"
              checked={reminder.refill_reminder}
              onCheckedChange={()=> toggleNotificationReminder("refill_reminder")}
            />
          </div>
        <Separator className="!my-0"/>
       
          <div className="flex items-center justify-between p-4 m-0">
            <Label htmlFor="daily" className="text-sm font-medium" >Receive daily reminders to take your medication</Label>
            <Switch
              id="daily"
              checked={reminder.daily_reminder}
              onCheckedChange={()=> toggleNotificationReminder("daily_reminder")}
            />
          </div>
     
      </CardContent>
    </Card>
  );
}

export default ReminderCard